import { ButtonTriggerEvent } from '../../../../common/components';

export class SetContactsModalActions {
    confirm: (event: ButtonTriggerEvent) => void;
    cancel?: () => void;
}

export class SetContactsModalData {
    name: string;
    number: string;
    email: string;
    inquiryEmail: string;
    account: any;
    constructor(account?, name?, number?, email?, inquiryEmail?) {
        this.account = account;
        this.name = name;
        this.number = number;
        this.email = email;
        this.inquiryEmail = inquiryEmail;
    }
}


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/admin/accounts/set.contacts/set.contacts.modal.provider.ts